import React from "react";

export default class LearningPlanExamResults extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    console.log("LearningPlanExamResults props", this.props);
    return (
      <ul className="learning-plan-exam-results list-group">
        {this.renderQuestions()}
      </ul>
    );
  }

  renderQuestions() {
    const { results } = this.props;
    return results.map((result, i) => {
      const { question, response, correct, rationale, context } = result;
      if (question) {
        return this.renderQuestion(
          question,
          response,
          correct,
          rationale,
          context,
          i
        );
      }
    });
  }

  renderQuestion(question, response, correct, rationale, context, idx) {
    const { id, statement, options } = question;
    return (
      <li className="list-group-item" key={id}>
        <p style={{ fontWeight: "bold" }}>{statement}</p>
        <div className="options">
          {options.map((option, idx) =>
            this.renderOption(option, response, idx)
          )}
        </div>
        <p className="correct-incorrect">
          {correct ? (
            <span className="correct">{I18n.t("correct")}</span>
          ) : (
            <span className="incorrect">{I18n.t("incorrect")}</span>
          )}
        </p>
        {(this.props.course || this.props.courses) &&
        this.props.articleLinks &&
        !correct ? (
          <p>
            {I18n.t("you_can_find_the_correct_answer")}{" "}
            {this.getArticleLink(
              context["pips.article.id"],
              context["pips.course.id"]
            )}
            .
          </p>
        ) : null}
      </li>
    );
  }

  renderOption(option, response, idx) {
    const { statement } = option;
    const { options = [] } = response;
    const option_id = options.length ? options[0] : {};
    const checked = option_id.id == option.id;
    return (
      <div className="option" key={idx}>
        <input type="radio" disabled checked={checked} /> {statement}
      </div>
    );
  }

  getArticleLink(id, course_id) {
    const { learning_plan } = this.props;
    if (this.props.course) {
      var { course } = this.props;
      var article = course.articles.find((article) => {
        return article.public_id === id;
      });
    } else if (this.props.courses) {
      var course = this.props.courses.find((course) => {
        return course.public_id === course_id;
      });
      var article = course.articles.find((article) => {
        return article.public_id === id;
      });
    }

    if (article) {
      var { path } = article;
      if (!path) {
        var learning_plan_item = null;
        learning_plan.learning_plan_sections.map(
          (learning_plan_section, _index) => {
            return learning_plan_section.learning_plan_items.map(
              (_learning_plan_item, _index) => {
                if (
                  _learning_plan_item.learnable_type === "Course" &&
                  _learning_plan_item.learnable.public_id == course_id
                ) {
                  learning_plan_item = _learning_plan_item;
                }
              }
            );
          }
        );
        var path = `/classroom/${learning_plan.account_public_id}/learning_plan/${learning_plan.id}/${learning_plan_item.id}/${id}`;
      }

      return (
        <a
          href={path}
          dangerouslySetInnerHTML={{
            __html: I18n.t("in_article_in_course", {
              course: course.name,
              article: article.name,
            }),
          }}
          style={{ textDecoration: "underline" }}
        ></a>
      );
    }
  }
}
